import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: [],
	columnFields: constants.job.search.columnFields,
	standardFilterFields: ['category', 'metadata.type'] as const,
	dateFilterFields: [],
	stageStatusFilterFields: [],
	booleanFilterFields: [] as const,
});
